import React from "react";
import { Reveal, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { SectionHeading } from "@/components/sections/SectionHeading";
import { INSIGHTS, MANIFESTO } from "@/data/content";

export const Insight = () => {
  return (
    <section id="insight" data-testid="insight-section" className="relative bg-ivory py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        {/* Manifesto chapters */}
        <div className="grid gap-14 lg:grid-cols-[0.9fr_1.1fr]">
          <SectionHeading
            overline="The insight"
            title="Wealth that outlives the moment"
            accentWord="outlives"
            subtitle="Three quiet truths about how Indian families really build lasting wealth — and the gap Shreedhan was built to close."
          />

          <div className="space-y-10">
            {MANIFESTO.map((m, i) => (
              <Reveal key={m.n} delay={i * 0.1}>
                <div className="group flex gap-6 border-b border-amber-200/50 pb-8 last:border-0">
                  <span className="font-serif text-3xl font-light text-gold-gradient">{m.n}</span>
                  <div>
                    <h3 className="font-serif text-2xl font-normal text-charcoal">{m.head}</h3>
                    <p className="mt-2 leading-relaxed text-charcoal-soft">{m.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        {/* 3-column insight cards */}
        <StaggerGroup className="mt-20 grid gap-6 md:grid-cols-3">
          {INSIGHTS.map((item) => (
            <StaggerItem key={item.title}>
              <div className="glass-card group h-full rounded-3xl p-8 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_48px_-12px_rgba(212,175,55,0.25)]">
                <div className="mb-6 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-gold/15 to-gold-rose/20">
                  <item.icon className="h-6 w-6 text-gold" strokeWidth={1.8} />
                </div>
                <span className="text-xs font-semibold uppercase tracking-[0.18em] text-gold">{item.tag}</span>
                <h3 className="mt-2 font-serif text-2xl font-normal text-charcoal">{item.title}</h3>
                <p className="mt-3 leading-relaxed text-charcoal-soft">{item.body}</p>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>
      </div>
    </section>
  );
};
